"use strict";

var _interopRequireDefault = require("/builds/frontend/web/agent/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.function.name.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/builds/frontend/web/agent/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/builds/frontend/web/agent/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/builds/frontend/web/agent/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _validate = require("@/utils/validate");
// import Vue from 'vue'

// progress bar
// progress bar style

var cRoles = [];
var accessRoutes;
var flag = true;
_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configurationmail/rental_inquiry/{id}
var whiteList = ['/401', '/404']; // no redirect whitelist

_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(to, from, next) {
    var _yield$store$dispatch, roles, hasRoles;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (to.path === '/login') cRoles = [];
          if (to.meta.noCache === false) {
            _store.default.dispatch('tagsView/addCachedView', to);
          }
          if (!(to.path !== '/' && to.path !== '/login')) {
            _context.next = 45;
            break;
          }
          if (flag && !to.meta.isWhite && whiteList.indexOf(to.path) === -1 && !(0, _validate.isInquiry)(to.path) && to.path !== '/dashboard' && _store.default.getters.scope === 1) {
            flag = false;
            _store.default.dispatch('user/accountQuota');
          }
          // start progress bar
          _nprogress.default.start();
          // set page title
          // document.title = getPageTitle(to.meta.title, to.meta.independent)
          // determine whether the user has logged in
          if (!(whiteList.indexOf(to.path) !== -1 || (0, _validate.isInquiry)(to.path) || to.meta.isWhite)) {
            _context.next = 9;
            break;
          }
          // 是白名单的route
          next();
          _context.next = 43;
          break;
        case 9:
          if (!(!_store.default.getters.token && !whiteList.indexOf(to.path) !== -1 && !(0, _validate.isInquiry)(to.path))) {
            _context.next = 12;
            break;
          }
          _router.default.push('/login');
          return _context.abrupt("return");
        case 12:
          cRoles = _store.default.getters.roles;
          if (!(!cRoles.length > 0)) {
            _context.next = 19;
            break;
          }
          _context.next = 16;
          return _store.default.dispatch('user/getUserInfo');
        case 16:
          _yield$store$dispatch = _context.sent;
          roles = _yield$store$dispatch.roles;
          cRoles = roles;
        case 19:
          if (!(cRoles && cRoles.length > 0)) {
            _context.next = 41;
            break;
          }
          hasRoles = _store.default.getters.roles && _store.default.getters.roles.length > 0;
          if (!(hasRoles && _store.default.getters.permission_routes && _store.default.getters.permission_routes.length > 0)) {
            _context.next = 25;
            break;
          }
          next();
          _context.next = 39;
          break;
        case 25:
          _context.prev = 25;
          _context.next = 28;
          return _store.default.dispatch('permission/generateRoutes', cRoles);
        case 28:
          accessRoutes = _context.sent;
          _router.default.selfaddRoutes(_router.default, accessRoutes);
          next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
            replace: true
          }));
          _context.next = 39;
          break;
        case 33:
          _context.prev = 33;
          _context.t0 = _context["catch"](25);
          _context.next = 37;
          return _store.default.dispatch('user/resetInfo');
        case 37:
          // 报错清空登录信息
          _router.default.push({
            path: '/login'
          });
          _nprogress.default.done();
        case 39:
          _context.next = 43;
          break;
        case 41:
          if (to.path.indexOf('/clue') !== -1) _router.default.push({
            path: "/login?redirect=".concat(to.path)
          });else if (to.path !== '/login') _router.default.push({
            path: '/login'
          });
          _nprogress.default.done();
        case 43:
          _context.next = 46;
          break;
        case 45:
          next();
        case 46:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[25, 33]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function (to, from) {
  if (from.meta.noCache === false) {
    var _from$meta = from.meta,
      keepComponentPages = _from$meta.keepComponentPages,
      alwaysKeep = _from$meta.alwaysKeep; // alwaysKeep 一直被缓存
    if (!alwaysKeep && (!keepComponentPages || !keepComponentPages.includes(to.name))) {
      _store.default.dispatch('tagsView/delCachedView', from);
    }
  }
  _nprogress.default.done();
});